module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAARklEQVR42mMgDYwC71bvn97/sUGgeCs2DX9Akri0YNPwHx/EqQGX+NC1gYAGfJCieCAc078QMY2prQGspIGUNNWApnwUAADy3bgoh+DlMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comment-24.png
// module id = XRJK
// module chunks = 1